export { default } from './sanitizeTemplateArea'
export * from './sanitizeTemplateArea'
